(() => {
  if (window.mostarlePartsValidation) return;
  window.mostarlePartsValidation = true;
  function update(event) {
    const field = event.target;
    if (!field.matches || !field.matches('[data-parts-field]')) return;
    const form = field.closest('[data-parts-form]');
    if (!form) return;
    const error = form.querySelector('#' + field.id + '-error');
    if (!error) return;
    const invalid = !field.validity.valid;
    field.setAttribute('aria-invalid', String(invalid));
    error.textContent = invalid ? field.validationMessage : '';
  }
  document.addEventListener('invalid', update, true);
  document.addEventListener('input', event => {
    if (event.target.getAttribute('aria-invalid') === 'true') update(event);
  });
  document.addEventListener('change', update);
})();
